window.timberSlider = window.timberSlider || {};

timberSlider.cacheSelectors = function () {
  timberSlider.cache = {
    // Home Page
    $slider: $('.flexslider'),
    $sliderImages: $('.flexslider img') // Cache the slider images
  };
};

timberSlider.init = function () {
  timberSlider.cacheSelectors();
  timberSlider.sliders();
  timberSlider.makeImagesResponsive();
};

timberSlider.sliders = function () {
  var $slider = timberSlider.cache.$slider,
      sliderArgs = {
        animation: 'slide',
        animationSpeed: 500,
        pauseOnHover: true,
        keyboard: false,
        slideshow: true,
        slideshowSpeed: 5000,
        smoothHeight: true
      };

  if ($slider.length) {

    if ($slider.find('li').length === 1) {
      sliderArgs.slideshow = false;
      sliderArgs.slideshowSpeed = 0;
      sliderArgs.controlNav = false;
      sliderArgs.directionNav = false;
      sliderArgs.touch = false;
    }

    $slider.flexslider(sliderArgs);
  }
};

// Function to make images responsive
timberSlider.makeImagesResponsive = function() {
  function updateImageStyles() {
    var $images = timberSlider.cache.$sliderImages;
    if (window.innerWidth < 768) {
      $images.css({
        'width': '100%',
        'height': 'auto',
        'object-fit': 'cover'
      });
    } else {
      $images.css({
        'width': '',
        'height': '',
        'object-fit': ''
      });
    }
  }

  // Run on load and on resize
  updateImageStyles();
  $(window).on('resize', updateImageStyles);
};

// Initialize slider earlier (no need to wait for all images)
$(document).ready(function() {
  timberSlider.init();
});
